import { useQuery } from '@tanstack/react-query';

import { listQueryOptions } from '@/lib/query-client';
import { makeQueryKeys } from '@/lib/query-keys';

import { redFlagsService } from '../services';
import type { RedFlagListParams } from '../types';

export const redFlagsKeys = makeQueryKeys('red-flags');

export function useRedFlags(params: RedFlagListParams = {}) {
  return useQuery({
    queryKey: redFlagsKeys.list(params),
    queryFn: () => redFlagsService.list(params),
    ...listQueryOptions,
  });
}
